module.exports = __webpack_public_path__ + "h5/img/left-icon.b07756cb.png";